exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"importLoaders":2}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/client/client.scss
// module id = ./node_modules/css-loader/index.js?{"minimize":false,"sourceMap":false,"importLoaders":2}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/client/client.scss
// module chunks = 4